
<template>
	<v-container class="mt-4 ml-2" fluid>

    <v-row>

      <v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Documentos Oficiales</span>
	  		    <v-spacer></v-spacer>

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              dark
              class="text-capitalize mr-2"
              @click="crearProceso()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Crear
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize mr-2"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>


	  		  </v-card-title>
	  		  <v-card-text>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="procesosFiltrados"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
                dense>

                <template v-slot:item.index="{ index }">{{ index + 1 }}</template>
                <template v-slot:item.acciones="{ item, index }">
                  <div style="display: flex; padding: 0.4rem;">
                    <v-btn class="mr-3" small @click="abrirDialog(item)">Ver</v-btn>

                    <v-btn v-if="puedeEliminarProceso" color="red" dark small @click="eliminar(item)">
                      <v-icon left small>mdi-delete</v-icon>
                      Eliminar
                    </v-btn>

                  </div>
                </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>

    </v-row>

    <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card class="shadowCard">

        <!-- Header -->
        <v-card-title primary-title>
          <span class="text-subtitle-1">Procesos</span>
          <v-spacer></v-spacer>
          <v-btn
              v-if="puedeEditar"
              color="primary"
              dark
              class="text-capitalize mr-2"
              @click="editarProceso()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Editar
            </v-btn>
        </v-card-title>

        <!-- Contenido -->
        <v-card-text>

          <!-- Título del proceso -->
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="form.titulo"
                label="Título del proceso"
                :disabled="!modoEdicion"
                filled
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Editor Quill -->
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-2 mb-2">Contenido del proceso:</div>

              <quill-editor
                v-model="form.proceso"
                :options="editorOptions"
                :disabled="!modoEdicion"
                style="background: white;"
              />
            </v-col>
          </v-row>

          <!-- Observaciones -->
          <v-row class="mt-4">
            <v-col cols="12">
              <v-textarea
                v-model="form.observacion"
                label="Observaciones"
                :disabled="!modoEdicion"
                filled
                dense
                auto-grow
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- Botones -->
          <v-row justify="end">

            <v-col cols="12" md="3">
              <v-btn
                color="red"
                dark
                tile
                block
                small
                @click="dialog = false"
              >
                Cancelar
              </v-btn>
            </v-col>

            <v-col v-if="modoEdicion"
            cols="12" md="3">
              <v-btn
                color="green"
                dark
                tile
                block
                small
                @click="guardar"
              >
                <v-icon left small>mdi-content-save</v-icon>
                Guardar
              </v-btn>
            </v-col>

          </v-row>

        </v-card-text>

      </v-card>

    </v-dialog>

    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>

<script>

  import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      // tabla
			search:'',
      procesos: [],
      headers: [
        { text: '#'         , value: 'index'      },
        { text: 'Usuario'         , value: 'nombre_completo'      },
        { text: 'Departamento'   , value: 'departamento'},
        { text: 'Titulo'         , value: 'titulo'      },
        { text: 'Observaciones'  , value: 'observacion' },
        { text: ''          , value: 'acciones'       },
      ],


      modalEditar: true, // voy a crear
      modoEdicion: false, // true = editar, false = solo lectura
      puedeEditar: false,

      form: {
        id: null,
        id_departamento: '',
        id_usuario: '',
        nombre_completo: '',
        titulo: '',
        proceso: '',
        observacion: ''
      },

      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],        // Estilos básicos
            [{ 'header': 1 }, { 'header': 2 }],     // Encabezados
            [{ 'list': 'ordered'}, { 'list': 'bullet' }], // Listas
            ['clean']                               // Quitar formato
          ]
        }
      },

      dialog: false,

      departamentos: [
        {
          id: 1,
          departamento: 'Sistemas'
        }
      ],

      departamentoFiltro: ''

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

      procesosFiltrados() {
        // si no hay filtro seleccionado, regresar la lista completa
        if (!this.departamentoFiltro) {
          return this.procesos;
        }

        // aquí se filtra por id del departamento
        return this.procesos.filter(
          p => p.id_departamento === this.departamentoFiltro
        );
      },

    },



    async created () {

      await this.initialize( )
    },

    methods: {

      initialize () {
      	this.cargar = true
        this.procesos = []
        //return this.$http.get('organigrama.v2').then(response=>{
        return this.$http.get('get.procesos.por.departamento', {
          params: {
            id_usuario: this.getdatosUsuarioERPERP.iderp
          }
        }).then(response=>{
          this.procesos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      abrirDialog(item){

        this.form = item
        this.modoEdicion = false
        this.dialog = true
        this.puedeEditar = false

        if( this.tieneAccesoAlProceso(item) ) this.puedeEditar = true
      },

      guardar() {

        if(!this.form.id_usuario){
          this.form.id_usuario = this.getdatosUsuarioERPERP.id_usuario
          this.form.nombre_completo = this.getdatosUsuarioERPERP.nombre_completo
        }

        this.form.titulo
        this.form.proceso

        if (!this.form.titulo || !this.form.proceso) {

          this.$swal({
            icon: 'warning',
            title: 'Campos incompletos',
            text: 'Debes llenar el título y el proceso.',
            confirmButtonText: 'Aceptar'
          });
          return;
        }

        console.log( this.form )

        return this.$http.post('crear.proceso', this.form).then(response=>{

          this.$swal({
            icon: 'success',
            title: 'Proceso guardado',
            text: 'El proceso se guardo correctamente.',
            confirmButtonText: 'Aceptar'
          });

        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {
          this.form = {
            id: null,
            id_departamento: '',
            id_usuario: '',
            nombre_completo: '',
            titulo: '',
            proceso: '',
            observacion: ''
          },
          this.modoEdicion = false
          this.cargar = false
          this.dialog = false
          this.initialize()
        })


      },

      crearProceso() {
        this.modoEdicion = true
        this.dialog = true
      },

      editarProceso() {

        this.modoEdicion = true

      },

      tieneAccesoAlProceso(item){
        return item.id_usuario === this.getdatosUsuarioERPERP.iderp ||
        [1, 334, 2345].includes(this.getdatosUsuarioERPERP.iderp)
      },

      eliminar(item) {
        const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        if (id !== 1 && id !== 334) return
        this.$swal({
          title: '¿Eliminar este proceso?',
          text: "Esta acción no se puede deshacer.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {

            this.$http.delete('eliminar.proceso', { data: { id: item.id } })
              .then(() => {
                this.$swal({
                  icon: 'success',
                  title: 'Eliminado',
                  text: 'El proceso se eliminó correctamente'
                });
                this.initialize(); // recarga la tabla
              })
              .catch(error => {
                this.validarError(error.response.data.message);
              });

          }
        });
      }

    },
  }
</script>

<style>

/* LISTA NUMERADA (1.-, 2.-) */
.ql-editor ol {
  counter-reset: myCounter;
  padding-left: 2em;
  margin-bottom: 1em;
}

.ql-editor ol > li {
  list-style: none;          /* quitamos estilo predeterminado */
  counter-increment: myCounter;
  margin-bottom: 0.25em;
}

.ql-editor ol > li::before {
  content: counter(myCounter) ".- ";
  font-weight: bold;
  display: inline-block;
  width: 2em;                /* espacio antes del texto */
}

/* LISTA CON VIÑETAS (punto centrado) */
.ql-editor ul {
  list-style: none;          /* quitamos viñetas predeterminadas */
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.ql-editor ul > li {
  position: relative;
  padding-left: 1em;
  margin-bottom: 0.25em;
}

.ql-editor ul > li::before {
  content: "•";              /* o "." si quieres literal punto */
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
}


</style>

